import React from 'react'

function Transactions() {
  return (
    <div className='py-[28px]'>Transactions</div>
  )
}

export default Transactions